import { DocumentRequestTemplateJsonResponse } from "../../common/model/sse/jsonResponse";
import { createCommonJsonResponse } from "../objectTypeConstants";

export const documentRequestTemplateJsonResponse: DocumentRequestTemplateJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        documentRequestTemplateId: 0,
        name: "string",
        description: "string",
        createdDate: "string",
        modifiedDate: "string",
        year: 0,
        dueDate: "string",
        documentList: [{
            name: "string",
            description: "string",
            documentCategory: {
                count: 0,
                documentCategoryId: 0,
                name: "string",
                createdDate: "2024-11-22T06:18:20.246Z",
                modifiedDate: "2024-11-22T06:18:20.246Z",
                createdBy: 0
            }
        }]
    }]
}